<a
    [attr.data-btnId]="getElementId('openElementInfo')"
    ngbTooltip="{{ tooltipContents }}"
    (click)="openDetails()">
    <fa-icon [icon]="['fas', icon]"></fa-icon>
</a>
